export const uk = {
    'combinator-tab': 'Комбинатор фраз',
    'manual-input-tab': 'Ручной ввод'
};
